export enum SonarNotificationLevel {
	Error = 'error',
	Info = 'info',
	Success = 'success',
	Urgent = 'urgent',
	Warning = 'warning',
}

export type SonarNotification = {
	notificationId: number;
	isRead: boolean;
	description: string;
	referenceId: number;
	timeStamp: string;
	title: string;
	notificationType: SonarNotificationType;
	level: SonarNotificationLevel;
};

export enum SonarNotificationType {
	AccessChangedApplicationBlocked = 'accessChangedApplicationBlocked',
	AccessLogExportReady = 'accessLogExportReady',
	DataAccessExportReady = 'dataAccessExportReady',
	DataDictionaryExportReady = 'dataDictionaryExportReady',
	IncidentLogExportReady = 'incidentLogExportReady',
	InitiativeCommentMention = 'initiativeCommentMention',
	InitiativeExportReady = 'initiativeExportReady',
	InitiativeLinkedJiraIssueDeleted = 'InitiativeLinkedJiraIssueDeleted',
	IntegrationDown = 'integrationDown',
	JiraIntegration = 'jiraIntegration',
	NewApplication = 'newApplication',
	NewFieldOrObjectAccess = 'newFieldOrObjectAccess',
	NewUser = 'newUser',
	AccessChangeLogExportReady = 'accessChangeLogExportReady',
	TimelineExportReady = 'timelineExportReady',
	ApiVolumeTableExportReady = 'appVolumeTableExportReady',
	SalesforceBulkPatchSummaryReady = 'salesforceBulkPatchSummaryReady',
	SalesforceBulkPatchAiSummaryReady = 'salesforceBulkPatchAiSummaryReady',
	SetupAuditTrailExportReady = 'setupAuditTrailExportReady',
	SetupAuditTrailMonitorAlert = 'setupAuditTrailMonitorAlert',
	NewFieldByConfigurableCriteriaAccessAlert = 'newFieldByConfigurableCriteriaAccessAlert',
	NewApplicationAccessBlocked = 'newApplicationAccessBlocked',
	AccessAnomalyExportReady = 'accessAnomalyExportReady',
}
